// @ts-check
import { AlertTriangle, X } from 'lucide-react';
import useAdminAlerts from '../hooks/useAdminAlerts';

/**
 * Undismissed admin alerts (e.g. a WhatsApp campaign the dispatcher paused, or one that finished
 * with some recipients failed), shown above every page's content - not only on the Dashboard,
 * which has its own richer banner and skips this one (see AdminLayout).
 */
const AdminAlertBanner = () => {
  const { alerts, dismiss } = useAdminAlerts();
  if (!alerts.length) return null;
  return (
    <div className="space-y-2 mb-4">
      {alerts.map((alert) => (
        <div
          key={alert.id}
          className="flex items-start gap-3 p-3 bg-amber-50 dark:bg-amber-950/50 border border-amber-300 dark:border-amber-800 rounded-lg"
        >
          <AlertTriangle size={18} className="text-amber-600 dark:text-amber-400 flex-shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-amber-800 dark:text-amber-300">{alert.title}</p>
            <p className="text-sm text-amber-700 dark:text-amber-300 mt-0.5 whitespace-pre-line">{alert.message}</p>
          </div>
          <button
            onClick={() => dismiss(alert.id)}
            className="p-1 text-amber-600 dark:text-amber-400 hover:text-amber-800 dark:hover:text-amber-300 flex-shrink-0"
            title="Dismiss"
          >
            <X size={16} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default AdminAlertBanner;
